module.exports = __webpack_public_path__ + "media/components/MedExpert_Globe_Blue-d79124ed8f07464dec240772647c1d4b.png";